"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRICE_SECTION = exports.MPR_STATEMENT = void 0;
const PRICE_SECTION = exports.PRICE_SECTION = 'price-section';
const MPR_STATEMENT = exports.MPR_STATEMENT = 'mpr-statement';
//# sourceMappingURL=constants.js.map